import { useAppSelector } from "@/redux/hooks/hooks";
import AddBank from "./components/AddBank";
import BillingHistory from "./components/BillingHistory";
import Earnings from "./components/Earnings";

import WalletHeader from "./components/WalletHeader";
import { useCreatorStatus } from "@/hooks/useCreatorStatuts";
import IncompleteApplicationReminderBanner from "../dashboard/components/IncompleteApplicationReminderBanner";

const Wallet = () => {
  const userEmail = useAppSelector((state) => state?.auth?.user?.email);

  const {
    shouldShowPopup,
    status,
    isError: isStatusError,
  } = useCreatorStatus(userEmail as string);

  return (
    <div className="mb-28 md:mb-10">
      <WalletHeader />
      {status?.isNotInitiated ? (
        <div className="px-4 md:px-11 pt-10" >
          <IncompleteApplicationReminderBanner />
        </div>
      ) : (
        <div className="px-4 md:px-11">
          {/* <AddBank /> */}
          <Earnings />
          {/* History */}
          <div className="mt-10">
            <h3 className="text-base font-medium leading-[22px] mb-6">
              Billing History
            </h3>
            <BillingHistory />
          </div>
        </div>
      )}
    </div>
  );
};

export default Wallet;
